var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: "添加优惠券",
        width: "606px",
        loading: _vm.loading,
        height: "auto",
        top: _vm.top,
      },
      on: { success: _vm.sure },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "CouponStyle",
        },
        [
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.radio,
                callback: function ($$v) {
                  _vm.radio = $$v
                },
                expression: "radio",
              },
            },
            [
              _c(
                "div",
                { staticClass: "couponStyleView" },
                _vm._l(_vm.list, function (item) {
                  return _c(
                    "div",
                    {
                      key: item.value,
                      staticClass: "couponStyleViewItem",
                      class: { checkRadio: item.value === _vm.radio },
                      on: {
                        click: function ($event) {
                          _vm.radio = item.value
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "CouponStyleImg",
                        attrs: { src: item.icon },
                      }),
                      _c(
                        "el-radio",
                        {
                          staticClass: "CouponStyleRadio",
                          attrs: { label: item.value },
                        },
                        [_vm._v(_vm._s(item.text))]
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }